<template>
  <div id="container">
    <div id="center" class="column">
      <div style="padding: 20px; text-align: center">
        <el-button @click="onThree" type="primary" v-if="!isPreview">下载PDF</el-button>
      </div>
      <div class="row" id="pdfDom" v-for="(item, index) in List" :key="index">
        <div v-for="(s, indexs) in item.infos" :key="indexs" class="tui-Box" :id="'page' + s._Index">
          <div class="header-all" v-if="s.CateName == '封面'" style="height: 1421.42px">
            <div class="tui-reportHeader">
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-6/2022-6-23/20220623135937_1734.png?x-oss-process=style/imgset"
                style="width: 12rem; height: 100%" alt="" crossOrigin="anonymous" />
              <div style="
                  position: absolute;
                  top: -20px;
                  left: 0;
                  right: 0;
                  text-align: center;
                ">
                <div class="TenanName">{{ userInfo.SchoolName }}</div>
                <div class="tui-reportTitle">
                  {{ s.StudentName }}成长手册（学校版）
                </div>
                <div class="flex-items tui-class">
                  <span></span>
                  <div>{{ s.GradeName + s.ClassName }}</div>
                  <span></span>
                </div>
              </div>
            </div>
            <div class="header-all-title">
              <div style="font-size: 25px; color: #fff; padding-bottom: 20px">
                记录者: {{ s.Content }}
              </div>
              <div style="font-size: 25px; color: #fff">
                {{ item.title }}
              </div>
            </div>
            <!-- <div class="header-all-title">
              <div class="tui-headerTitle" style="">
                {{ userInfo.SchoolName }}
              </div>
              <div class="tui-headerName">{{ s.StudentName }}成长手册</div>
              <p style="color: #4f6585; font-size: 31px">（学校版）</p>
              <div
                style="
                  font-size: 31px;
                  font-weight: bold;
                  color: #333;
                  padding-top: 100px;
                "
              >
                {{ s.GradeName }}{{ s.ClassName }}
              </div>
            </div>
            <div class="header-all-title" style="padding-top: 30px">
              <div
                style="font-size: 25px; font-weight: bold; padding-bottom: 30px"
              >
                记录者: {{ s.Content }}
              </div>
              <div style="font-size: 25px; font-weight: bold">
                {{ item.title }}
              </div>
            </div> -->
          </div>
          <!-- 寄语 -->
          <div class="send-all" v-else-if="s.CateName == '寄语'" style="height: 1421.42px">
            <div class="send-desc">
              <div class="">
                <div class="">{{ s.Content }}</div>
              </div>
            </div>
          </div>

          <!-- 维度 图片 文字评价  -->
          <div class="health-bg" v-if="s.Type == 3" :style="{
            height: '1421.42px',
            'background-image': 'url(' + bg(s.CateName) + ')',
          }">
            <div class="">
              <div class="header-top">
                <img src="../../assets/bg-header.png" alt="" />
                <div class="header-text" style="">{{ s.CateName }}</div>
              </div>
              <image-layout v-if="s.fileList.length != 0" :imageList="s.fileList" :downLoadFlag="downLoadFlag" />
              <div class="remark">
                <div class="jiankang1">
                  <div class="remark-desc" :style="{
                    'font-size':
                      s.Content.length <= 140
                        ? '24px'
                        : s.Content.length <= 300
                          ? '20px'
                          : '16px',
                  }">
                    {{ s.Content }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 表格1 -->
          <div style="
              background-color: rgba(198, 232, 255);
              position: relative;

              height: 1421.42px;
              padding: 0 40px 0 40px;
            " v-if="s.Type == 4">
            <el-row class="demo-el-row" v-if="s.Type == 4" style="padding-top: 40px">
              <el-col :span="12">
                <div class="dark bd-top bd-bottom bd-left bd-right" style="display: flex">
                  <div class="text-flex">
                    {{ tableParams.titleTab1 }}
                  </div>
                  <div class="table-input">
                    {{ tableParams.name }}
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="light bd-top bd-bottom bd-right" style="display: flex">
                  <div class="text-flex">
                    {{ tableParams.titleTab2 }}
                  </div>
                  <div class="table-input">
                    {{ tableParams.content }}
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="light bd-bottom bd-left bd-right" style="display: flex">
                  <div class="text-flex">
                    {{ tableParams.titleTab3 }}
                  </div>
                  <div class="table-input">
                    {{ tableParams.looktime }}
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="light bd-bottom bd-right" style="display: flex">
                  <div class="text-flex">
                    {{ tableParams.titleTab4 }}
                  </div>
                  <div class="table-input">
                    {{ tableParams.writename }}
                  </div>
                </div>
              </el-col>
              <el-col v-for="(item, index) in tableParams.List" :key="index">
                <div class="light bd-left bd-bottom bd-right" style="min-height: 120px; flex-direction: column">
                  <input v-model="item.title" class="table-textarea" style="padding-left: 10px"
                    placeholder-style="font-weight: bold;" :maxlength="10" />
                  <div class="table-inputs">{{ item.desc }}</div>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- 表格2 -->
          <div style="
              background-color: rgba(198, 232, 255);
              position: relative;
              padding: 0 40px 0 40px;
              overflow: hidden;
              height: 1421.42px;
            " v-if="s.Type == 5">
            <!-- 表格2第一页 -->
            <div class="table-header" style="padding-top: 40px">
              <el-row class="demo-el-row">
                <el-col>
                  <div class="demo-el-col dark bd-top bd-bottom bd-left bd-right" style="justify-content: center">
                    <div class="input-table">
                      {{ getName(s.Content) }}
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="demo-el-col dark bd-bottom bd-left">
                    <div class="" style="
                        font-size: 18px;
                        font-weight: bold;
                        margin: 0 auto;
                        color: #000;
                      ">
                      表现
                    </div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="demo-el-col dark bd-bottom bd-left">
                    <div class="" style="
                        font-size: 18px;
                        font-weight: bold;
                        margin: 0 auto;
                        color: #000;
                      ">
                      真棒
                    </div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="demo-el-col dark bd-bottom bd-left">
                    <div class="" style="
                        font-size: 18px;
                        font-weight: bold;
                        margin: 0 auto;
                        color: #000;
                      ">
                      较好
                    </div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="demo-el-col dark bd-bottom bd-left bd-right">
                    <div class="" style="
                        font-size: 18px;
                        font-weight: bold;
                        margin: 0 auto;
                        color: #000;
                      ">
                      加油
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row class="demo-el-row" v-for="(item, index) in s.table" :key="index">
                <el-col :span="12">
                  <div class="demo-el-col dark bd-bottom bd-left">
                    <div class="input-table" style="">
                      {{ item.manifestation }}
                    </div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="demo-el-col dark bd-bottom bd-left">
                    <div class="" style="
                        font-size: 16px;
                        font-weight: bold;
                        margin: 0 auto;
                        color: #000;
                      ">
                      <img :src="item.isActivite == 1
                          ? require('../../assets/state_activite.png')
                          : require('../../assets/state.png')
                        " @click="onClickRate(1, index)" style="width: 26px; height: 26px" alt="" />
                    </div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="demo-el-col dark bd-bottom bd-left">
                    <div class="" style="
                        font-size: 14px;
                        font-weight: bold;
                        margin: 0 auto;
                        color: #000;
                      ">
                      <img :src="item.isActivite == 2
                          ? require('../../assets/state_activite.png')
                          : require('../../assets/state.png')
                        " lazy-load style="width: 26px; height: 26px" mode="" @click="onClickRate(2, index)" />
                    </div>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="demo-el-col dark bd-bottom bd-left bd-right">
                    <div class="" style="
                        font-size: 14px;
                        font-weight: bold;
                        margin: 0 auto;
                        color: #000;
                      ">
                      <img :src="item.isActivite == 3
                          ? require('../../assets/state_activite.png')
                          : require('../../assets/state.png')
                        " lazy-load style="width: 26px; height: 26px" mode="" @click="onClickRate(3, index)" />
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>

          <!-- 表格2其他页 -->
          <div style="
              background-color: rgba(198, 232, 255);
              position: relative;
              padding: 0 40px 0 40px;
              overflow: hidden;
              height: 1421.42px;
            " class="paramsTwo" :key="index" v-if="s.Type == -5">
            <el-row class="demo-el-row" v-for="(itemChild, index) in s.table" :key="index">
              <el-col :span="12">
                <div class="demo-el-col dark bd-bottom bd-left">
                  <div class="input-table">
                    {{ itemChild.manifestation }}
                  </div>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="demo-el-col dark bd-bottom bd-left">
                  <div class="" style="
                      font-size: 16px;
                      font-weight: bold;
                      margin: 0 auto;
                      color: #000;
                    ">
                    <img :src="itemChild.isActivite == 1
                        ? require('../../assets/state_activite.png')
                        : require('../../assets/state.png')
                      " @click="onClickRate(1, index)" style="width: 26px; height: 26px" alt="" />
                  </div>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="demo-el-col dark bd-bottom bd-left">
                  <div class="" style="
                      font-size: 14px;
                      font-weight: bold;
                      margin: 0 auto;
                      color: #000;
                    ">
                    <img :src="itemChild.isActivite == 2
                        ? require('../../assets/state_activite.png')
                        : require('../../assets/state.png')
                      " lazy-load style="width: 26px; height: 26px" mode="" @click="onClickRate(2, index)" />
                  </div>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="demo-el-col dark bd-bottom bd-left bd-right">
                  <div class="" style="
                      font-size: 14px;
                      font-weight: bold;
                      margin: 0 auto;
                      color: #000;
                    ">
                    <img :src="itemChild.isActivite == 3
                        ? require('../../assets/state_activite.png')
                        : require('../../assets/state.png')
                      " lazy-load style="width: 26px; height: 26px" mode="" @click="onClickRate(3, index)" />
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- 本月任务顺利完成 -->
          <div id="tui-buttom" v-if="s.CateName == '封底'">
            <img src="../../assets/fengdi-f1.png" style="width: 100%; height: 1421px" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import download from "../../../util/downLoad";
import imageLayout from "../../components/imageLayout.vue";
import html2Canvas from "html2canvas";
import {
  FrontAutoPdfInfo,
  MsaveImage,
  AutoPdfDownInfo,
  SetAutoPdfInfo,
} from "../../api/api";
export default {
  data() {
    return {
      fileName: "aaa",
      List: [],
      title_1: "学生表现：",
      title_2: "问题原因：",
      title_3: "解决问题计划：",
      title_4: "变化/成长：",
      tableParams: {
        //表格1的内容
        name: "",
        content: "",
        looktime: "",
        writename: "",
        performance: "",
        questionreason: "",
        Problemplan: "",
        change: "",
        List: [],
      },

      GuidList: [],
      PageIndex: "", //报告页数
      isPreview: false,
      userInfo: {},
      downLoadFlag: false,
      paramsList: [],
    };
  },
  mounted() {
    if (this.$route.query.Type == 1) {
      this.isPreview = true;
      setTimeout(() => {
        this.onThreeAuto();
      }, 1000);
    }
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    await this.__init();
  },
  components: {
    imageLayout,
  },
  methods: {
    getName(val) {
      if (val) {
        let list = JSON.parse(val);
        console.log(list);
        return list.title;
      }
    },
    bg(text) {
      if (
        text == "健康" ||
        text == "健康与体能" ||
        text == "感知与运动" ||
        text == "发育与健康"
      ) {
        return require("@/assets/jiankang1.png");
      } else if (
        text == "社会" ||
        text == "情感与社会性" ||
        text == "自我与社会性"
      ) {
        return require("@/assets/shehui1.png");
      } else if (text == "习惯与自理") {
        return require("@/assets/xiguang1.png");
      } else if (text == "校本特色") {
        return require("@/assets/xiaoben.png");
      } else if (
        text == "语言" ||
        text == "认知与语言" ||
        text == "语言与交流"
      ) {
        return require("@/assets/yuyan1.png");
      } else if (text == "科学" || text == "探究与认知") {
        return require("@/assets/kexue1.png");
      } else if (text == "艺术" || text == "美感与表现") {
        return require("@/assets/yishu1.png");
      } else {
        return require("@/assets/defaultBg.png");
      }
    },
    /*
     * 使用download.js 强制浏览器下载图片、视频等文件
     * @param {any} url url链接地址
     * @param {any} strFileName 文件名
     * @param {any} strMimeType 文件类型
     * dzl
     */
    downloadfile(url, strFileName, strMimeType) {
      var xmlHttp = null;
      if (window.ActiveXObject) {
        // IE6, IE5 浏览器执行代码
        xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
      } else if (window.XMLHttpRequest) {
        // IE7+, Firefox, Chrome, Opera, Safari 浏览器执行代码
        xmlHttp = new XMLHttpRequest();
      }
      //2.如果实例化成功，就调用open（）方法：
      if (xmlHttp != null) {
        xmlHttp.open("get", url, true);
        xmlHttp.responseType = "blob"; //关键
        xmlHttp.send();
        xmlHttp.onreadystatechange = doResult; //设置回调函数
      }
      function doResult() {
        if (xmlHttp.readyState == 4) {
          //4表示执行完成
          if (xmlHttp.status == 200) {
            //200表示执行成功
            download(xmlHttp.response, strFileName, strMimeType);
          }
        }
      }
    },
    guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    onThreeAuto() {
      let that = this;
      this.$set(this, "downLoadFlag", true);
      var Name = this.$route.query.StudentName;
      const loading = this.$loading({
        lock: true,
        text: "正在下载PDF",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(() => {
        let length = this.PageIndex;
        let pageSize = 5; //每次向后台发送十张
        let page = Math.ceil(length / pageSize); //需要发送的次数
        let i = 0; //当前发送的次数
        // 递归函数
        async function fn() {
          // length
          let End =
            pageSize * i + pageSize <= length
              ? pageSize * i + pageSize
              : length;
          let pageBase = [];
          for (let index = pageSize * i; index < End; index++) {
            let content = document.querySelector("#page" + index);
            let canvas = await html2Canvas(content, {
              useCORS: true,
              dpi: 172, //导出pdf清晰度
              scale: 2, // 提升画面质量，但是会增加文件大小
            });
            let pageData = canvas.toDataURL("image/jpeg", 1.0);
            if (pageData != "data: ," && pageData != "data:,") {
              pageBase.push({
                guid: index + 100 + "_" + that.guid(),
                baseimg: pageData,
                name: "#page" + index,
              });
            }
          }
          that.GuidList = that.GuidList.concat(pageBase);

          i++;
          let xhr = await MsaveImage({
            list: isData,
          });
          console.log(xhr.data.success);
          if (!xhr.data.success) {
            that.$notify({
              title: "提示",
              message: "生成失败",
              duration: 0,
            });

            loading.close();
            return;
          }
          if (i < page) {
            setTimeout(() => {
              fn();
            }, 500);
          } else {
            that.GuidList.forEach((a) => {
              a.baseimg = "";
            });
            let GuidList = that.GuidList.filter((cc) => {
              return cc.baseimg != "data:," && cc.baseimg != "data: ,";
            });
            console.log(GuidList, "GuidList");
            AutoPdfDownInfo({
              name: `${Name}成长手册`,
              list: that.uq(GuidList),
              Type: "过程评价",
            }).then((res) => {
              //console.log(res, "报告下载");
              loading.close();
              if (res.data.success) {
                //this.isVideo = true;
                window.close();
              } else {
                that.$notify({
                  title: "提示",
                  message: xhr.data.msg,
                  duration: 0,
                });
              }
            });
          }
        }
        fn();
      }, 500);
    },
    onThree() {
      let that = this;
      this.$set(this, "downLoadFlag", true);
      var Name = this.$route.query.StudentName;
      const loading = this.$loading({
        lock: true,
        text: "正在下载PDF",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(() => {
        let length = this.PageIndex;
        let pageSize = 5; //每次向后台发送十张
        let page = Math.ceil(length / pageSize); //需要发送的次数
        let i = 0; //当前发送的次数
        // 递归函数
        async function fn() {
          // length
          let End =
            pageSize * i + pageSize <= length
              ? pageSize * i + pageSize
              : length;
          let pageBase = [];
          console.log(End, i, "end");
          for (let index = pageSize * i; index < End; index++) {
            let content = document.querySelector("#page" + index);
            let canvas = await html2Canvas(content, {
              useCORS: true,
              dpi: 172, //导出pdf清晰度
              scale: 2, // 提升画面质量，但是会增加文件大小
            });
            let pageData = canvas.toDataURL("image/jpeg", 1.0);
            if (pageData != "data: ," && pageData != "data:,") {
              pageBase.push({
                guid: index + 100 + "_" + that.guid(),
                baseimg: pageData,
                name: "#page" + index,
              });
            }
          }
          that.GuidList = that.GuidList.concat(pageBase);

          i++;
          console.log(pageBase, "pageBase");
          let isData = pageBase;

          console.log(isData, "isData");
          let xhr = await MsaveImage({
            // name: "成长手册",
            list: isData,
          });
          if (xhr.data.success) {
            if (i < page) {
              setTimeout(() => {
                fn();
              }, 500);
            } else {
              let GuidList = that.GuidList.filter((cc) => {
                return cc.baseimg != "data:," && cc.baseimg != "data: ,";
              });
              GuidList.forEach((a) => {
                a.baseimg = "";
              });
              console.log(GuidList, "GuidList");
              that.$set(that, "downLoadFlag", false);
              SetAutoPdfInfo({
                name: `${Name}成长手册`,
                list: that.uq(GuidList),
              }).then((res) => {
                //console.log(res, "报告下载");
                loading.close();
                if (res.data.success) {
                  let idx = res.data.response.lastIndexOf(".");
                  if (idx != -1) {
                    let ext = res.data.response.substr(idx + 1).toUpperCase();
                    ext = ext.toLowerCase();
                    that.downloadfile(
                      res.data.response,
                      `${Name}成长手册`,
                      ext
                    );
                  }
                } else {
                  console.log(res);
                  that.$notify({
                    title: "提示",
                    message: xhr.data.msg,
                    duration: 0,
                  });
                }
              });
            }
          } else {
            console.log("失败了11111");
            that.$notify({
              title: "提示",
              message: xhr.data.msg,
              duration: 0,
            });
          }
        }
        fn();
      }, 500);
    },
    uq(array) {
      //将array数组转换成set对象,再使用Array.from()方法将set对象转换成数组
      return Array.from(new Set(array));
    },
    CloseWebPage() {
      if (navigator.userAgent.indexOf("MSIE") > 0) {
        if (navigator.userAgent.indexOf("MSIE 6.0") > 0) {
          window.opener = null;
          window.close();
        } else {
          window.open("", "_top");
          window.top.close();
        }
      } else if (navigator.userAgent.indexOf("Firefox") > 0) {
        window.location.href = "about:blank "; //火狐默认状态非window.open的页面window.close是无效的
      } else {
        window.opener = null;
        window.open("", "_self", "");
        window.close();
      }
    },
    joinData(arr) {
      arr.forEach((element) => {
        element._id = this.getId();
      });
      //console.log(arr, "arrr");
      return arr;
    },
    getId() {
      return (
        (Math.random() * 1000).toFixed(0).toString() +
        (Math.random() * 1000).toFixed(0).toString()
      );
    },
    //  获取数据
    async __init() {
      let res = await FrontAutoPdfInfo({
        Ids: JSON.parse(this.$route.query.Ids),
        studentId: this.$route.query.studentId,
      });
      this.List = [];
      this.PageIndex = 0;
      if (res.data.success) {
        res.data.response.forEach((item) => {
          let infos = [];
          item.infos.forEach((k) => {
            if (k.Type == 4) {
              //表格1
              if (k.Content != "") {
                this.tableParams = JSON.parse(k.Content);
              }
              infos.push(k);
            } else if (k.Type == 3) {
              let fileList = [];
              if (k.ImgList) {
                let imageArr = k.ImgList.split(",");
                imageArr.forEach((item) => {
                  if (item) {
                    fileList.push({
                      src: item,
                      type: "image",
                      _id: this.getId(),
                    });
                  }
                });
              }
              if (k.VideoList) {
                let VideoList = k.VideoList.split(",");
                VideoList.forEach((item) => {
                  if (item) {
                    fileList.push({
                      src: item,
                      type: "video",
                      _id: this.getId(),
                    });
                  }
                });
              }
              if (k.AudioList) {
                let AudioList = k.AudioList.split(",");
                AudioList.forEach((item) => {
                  if (item) {
                    fileList.push({
                      src: item,
                      type: "audio",
                      _id: this.getId(),
                    });
                  }
                });
              }
              k.fileList = fileList;
              // k.downLoadFlag = false;
              infos.push(k);
            } else if (k.Type == 5) {
              // 表格2
              if (k.Content != "") {
                let tabelTwoList = JSON.parse(k.Content);
                k.table = tabelTwoList.List.splice(0, 14);
                infos.push(k);
                // this.paramsOne = tabelTwoList.List.splice(0, 14);
                let paramsTwoResidue = tabelTwoList.List;
                let page = Math.ceil(paramsTwoResidue.length / 16);
                for (let i = 0; i < page; i++) {
                  let moreTable = JSON.parse(JSON.stringify(k));
                  // this.paramsTwo.push(paramsTwoResidue.splice(i, (i + 1) * 16));
                  moreTable.table = paramsTwoResidue.splice(i, (i + 1) * 16);
                  moreTable.Type = -5;
                  infos.push(moreTable);
                }
                // this.paramsList.push(JSON.parse(k.Content));
                this.params = JSON.parse(k.Content);
              }
            } else {
              infos.push(k);
            }
          });

          item.infos = infos;
        });
        this.List = res.data.response;
        //console.log(this.List);
        this.List.forEach((item) => {
          item.infos.forEach((i) => {
            i._Index = this.PageIndex;
            this.PageIndex++;
          });
        });
        console.log(this.List, this.PageIndex, "params");
      }
    },
  },
};
</script>
<style  lang="less" scoped>
.tui-Box {
  // height: 1421.42px;
  overflow: hidden;
}

#tui-buttom {
  display: flex;
  align-items: center;
  justify-content: center;
}

.demo-el-row {
  width: 95%;
  margin: 0 auto;
}

.paramsTwo .demo-el-row:nth-child(1) {
  margin-top: 40px;
  border-top: 1px solid #000000;
}

input::-webkit-input-placeholder {
  color: #000;
  font-size: 18px;
}

.input-table {
  font-size: 18px;
  display: inline-block;
  // height: 30px;
  // line-height: 30px;
  color: #000;
  white-space: normal;
  word-break: break-all;
}

.table-input {
  // width: 100%;
  height: 50px;
  font-size: 18px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-flex {
  max-width: 110px;
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  padding-left: 10px;
  flex-shrink: 0;
}

input {
  border: 0; // 去除未选中状态边框
  outline: none; // 去除选中状态边框
  background-color: rgba(0, 0, 0, 0); // 透明背景
}

.bd-top {
  border-top: 1px solid #000000;
}

.bd-bottom {
  border-bottom: 1px solid #000000;
}

.bd-left {
  border-left: 1px solid #000000;
}

.bd-right {
  border-right: 1px solid #000000;
}

.demo-el-col {
  min-height: 80px;
  display: flex;
  align-items: center;
  padding: 0 10px 0 10px;
}

.table-textarea {
  width: 20%;
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  padding-top: 10px;
  margin: 0 auto;
  background: rgb(198, 232, 255);
  text-align: left;
}

.table-inputs {
  width: 90%;
  font-size: 18px;
  font-weight: 500;
  color: #000000;
  padding: 10px;
  word-wrap: break-word;
  text-align: left;
  // margin: 0 auto;
  // background: rgb(198, 232, 255);
}

.jiankang1 {
  background: url(../../assets/jiyu-bg.png) no-repeat;
  height: 100%;
  width: 805px;
  margin: 0 auto;
  background-size: 805px 100%;
  background-repeat: no-repeat;
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.shehui1 {
  background: url(../../assets/shehui-bg.png) no-repeat;
  height: 100%;
  width: 805px;
  margin: 0 auto;
  background-size: 805px 100%;
  background-repeat: no-repeat;
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.yuyan1 {
  background: url(../../assets/shehui-bg.png) no-repeat;
  height: 100%;
  width: 805px;
  margin: 0 auto;
  background-size: 805px 100%;
  background-repeat: no-repeat;
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.health-shehui {
  background: url(../../assets/shehui1.png) no-repeat center center;
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}

.health-yuyan {
  background: url(../../assets/yuyan1.png) no-repeat center center;
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}

.health-tansuo {
  background: url(../../assets/kexue1.png) no-repeat center center;
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}

.health-xiaoben {
  background: url(../../assets/xiaoben.png) no-repeat center center;
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}

.health-yishu {
  background: url(../../assets/yishu1.png) no-repeat center center;
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}

.health-bg {
  background: url(../../assets/jiankang1.png) no-repeat center center;
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}

.health-xiguan {
  background: url(../../assets/xiguang1.png) no-repeat center center;
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}

.header-top {
  width: 100%;

  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  text-align: center;

  img {
    width: 353px;
    height: 157px;
  }

  .header-text {
    position: absolute;
    top: 75px;
    left: 0;
    right: 0;
    font-size: 50px;
    font-weight: bold;
    color: #ffae00;

    font-family: Lantinghei SC;
    // background: linear-gradient(0deg, #FFAE00 0.146484375%, #F54532 100%);
  }
}

.remark {
  position: absolute;
  right: 0;
  bottom: 2%;
  width: 100%;
  height: 330px;

  .remark-bg-activite {
    height: 100%;
    width: 507px;

    // background: url(../../static/image/jiyu-bg.png) no-repeat center center;
    background-size: 507px 100%;
    background-repeat: no-repeat;
    position: relative;
    margin-left: auto;
    right: 5%;
  }

  .remark-bg {
    height: 100%;
    width: 805px;
    margin: 0 auto;
    background-size: 805px 100%;
    background-repeat: no-repeat;
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }

  .remark-desc {
    position: absolute;
    right: 0;
    top: 20%;
    left: 0;
    font-size: 16px;
    margin: auto;
    padding: 0 20px 0 20px;
  }
}

.health-box {
  width: 92%;
  height: 691px;
  position: absolute;
  left: 0;
  right: 0;
  top: -15%;
  bottom: 0;
  margin: auto;

  .Home-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;

    .Home-item {
      width: calc(100% / 3 - 20px);
      height: 245px;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 10px;
      flex-direction: column;
      position: relative;
      background: url(../../assets/border-cart.png) no-repeat;
      background-size: 280px 245px;
    }
  }
}

.successBg {
  height: 1421.21px;
  background: url(../../assets/success-bg.png) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
}

.end-bg {
  height: 100%;
  background: url(../../assets/end-bg.png) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
}

.send-all {
  height: 100%;
  background: url(../../assets/jiyu1.png) no-repeat center center;
  background-size: 100% 100%;
  position: relative;

  .send-desc {
    width: 800px;
    height: 805px;

    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;

    div {
      font-size: 24px;
      line-height: 47px;
      letter-spacing: 5px;
      padding-top: 10px;
    }
  }
}

.tui-position {
  position: absolute;
  right: 20px;
  bottom: 20px;
  font-size: 25px;
  color: #fff;
}

.header-all {
  height: 100%;
  background: url(../../assets/newBG.png) no-repeat center center;
  background-size: 100% 100%;
  position: relative;

  .tui-reportHeader {
    width: 100%;
    margin: 0 auto;
    position: absolute;
    top: 190px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .TenanName {
      font-size: 40px;
      color: #fff;
    }

    .tui-reportTitle {
      font-size: 60px;
      color: #fff;
      padding-top: 20px;
    }

    .tui-class {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 20px;

      span {
        width: 0.225rem;
        height: 0.225rem;
        border-radius: 50%;
        background: #ffec8e;
      }

      div {
        font-size: 0.375rem;
        color: #ffec8e;
        font-weight: 600;
        letter-spacing: 0.0625rem;
        padding: 0 0.25rem;
      }
    }
  }

  .header-Name {
    text-align: center;
    text-shadow: 0px 6px 1px #fff;
    font-size: 70px;
    font-family: Lantinghei SC;
    font-weight: 800;
    color: #3ec53f;
    padding-top: 111px;
  }

  .tui-headerName {
    font-size: 73px;
    font-weight: bold;
    text-align: center;
    color: #4f6585;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 60px;
  }

  .tui-headerTitle {
    width: 717px;
    height: 184px;
    font-size: 84px;
    font-weight: bold;
    text-align: center;
    color: #4f6585;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .header-all-title {
    position: absolute;
    bottom: 43px;
    left: 0;
    right: 0;

    display: flex;
    align-items: center;
    flex-direction: column;
  }
}

#header,
#footer {
  background: rgba(29, 27, 27, 0.726);
  text-align: center;
  height: 60px;
  line-height: 60px;
}

#container {
  display: flex;
  justify-content: center;
}

#container .column {
  height: 100%;
  /* line-height: 300px; */
}

#center {
  width: 1000px;
  background: #fff;
}

#left {
  flex: 1;
}

#right {
  flex: 1;
}

.textOverflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>